import { Button } from 'antd'
import React from 'react'

const BasicButton = (props) => {
  const base =
    'rounded-none px-4 py-5 primary-btn-color text-lg font-bold primary-btn'
  const merged = props?.className ? `${base} ${props.className}` : base
  return (
    <Button
      htmlType={props?.type || 'button'}
      className={merged}
      onClick={props?.basicButtonHandler}
      disabled={props?.disabled}
    >
      {props?.text}
    </Button>
  )
}

export default BasicButton
